import React, { useEffect, useState } from "react";
import styled, { keyframes } from 'styled-components';
import aboutImage from "../assets/about.png";
import Heading from "./Heading";

function About() {
  const [aboutData, setAboutData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://raw.githubusercontent.com/anmolkumarshah/data-for-portfolio/main/data.json"
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setAboutData(data.about[0]);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const rotateBorder = keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `;

  const RotatingBorder = styled.div`
    position: relative;
    display: inline-block;
    margin: auto;
    width: 10rem;
    height: 10rem; /* Ensures a square container for circular border */

    @media (min-width: 640px) {
      width: 12rem;
      height: 12rem;
    }

    @media (min-width: 768px) {
      width: 16rem;
      height: 16rem;
      padding: 0;
    }

    @media (min-width: 1024px) {
      width: 20rem;
      height: 20rem;
    }

    &::before {
      content: "";
      position: absolute;
      top: -8px;
      left: -8px;
      right: -8px;
      bottom: -8px;
      border: 4px dashed white; /* White color and increased width */
      border-radius: 50%; /* Circular border */
      animation: ${rotateBorder} 2s ease-in-out infinite;
      pointer-events: none;
    }
  `;

  const Image = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 50%; /* Circular image */
  `;

  if (loading) {
    return <div className="text-white">Loading...</div>;
  }

  if (error) {
    return <div className="text-white">Error: {error}</div>;
  }

  return (
    <div >
      <div className="text-white max-w-[1200px] mx-auto" >
        <div className="md:grid md:grid-cols-2 sm:py-16">
          <div className="mt-4 md:mt-0 text-left flex">
            <div className="my-auto mx-4">
              <Heading id="about" text={"About Me"} />
              <p className="mx-3 text-base lg:text-xl italic text-justify my-4 md:my-0">
                {aboutData}
              </p>
            </div>
          </div>
          <div className="flex justify-center md:justify-end ">
            <RotatingBorder>
              <Image alt="about" src={aboutImage} />
            </RotatingBorder>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
